import axios from 'axios';
import constants from '@/constants';

const {
  API_STRING,
  API_FORM_STRING,
  PRODUCTS_COLLECTION_NAME,
  PAGES_COLLECTION_NAME,
  MAINPAGE_COLLECTION_NAME,
  FEATURE_COLLECTION_NAME,
  SLIDER_IMAGE,
  PRODUCTPAGE_FIELDS_COLLECTION_NAME,
  MENU_COLLECTION_NAME,
  FORMFIELDS_COLLECTION_NAME,
} = constants;

class Api {
  static getAllProducts() {
    const coolectionURL = `${API_STRING}/${PRODUCTS_COLLECTION_NAME}`;
    return axios.get(coolectionURL);
  }
  static getMenuItems() {
    const coolectionURL = `${API_STRING}/${MENU_COLLECTION_NAME}`;
    return axios.get(coolectionURL).then(({ data: { entries } }) => entries);
  }
  static getContentAbout() {
    const coolectionURL = `${API_STRING}/${PAGES_COLLECTION_NAME}`;
    return axios
      .get(coolectionURL)
      .then(({ data: { entries } }) =>
        entries.find(page => page.name === 'about'),
      );
  }
  static getProductPageFields() {
    const coolectionURL = `${API_STRING}/${PRODUCTPAGE_FIELDS_COLLECTION_NAME}`;
    return axios.get(coolectionURL).then(({ data: { entries } }) => entries[0]);
  }
  static getContentContacts() {
    const coolectionURL = `${API_STRING}/${PAGES_COLLECTION_NAME}`;
    return axios
      .get(coolectionURL)
      .then(({ data: { entries } }) =>
        entries.find(page => page.name === 'contacts'),
      );
  }
  static getContentMain() {
    const coolectionURL = `${API_STRING}/${MAINPAGE_COLLECTION_NAME}`;
    return axios.get(coolectionURL).then(({ data: { entries } }) => entries[0]);
  }
  static getFormFields() {
    const coolectionURL = `${API_STRING}/${FORMFIELDS_COLLECTION_NAME}`;
    return axios.get(coolectionURL).then(({ data: { entries } }) => entries[0]);
  }
  static getFeatures() {
    const coolectionURL = `${API_STRING}/${FEATURE_COLLECTION_NAME}`;
    return axios.get(coolectionURL).then(({ data: { entries } }) => entries);
  }
  static sendFom(data) {
    axios.post('/form.php', data);
    return axios.post(API_FORM_STRING, data);
  }
  static getPackageImageById(id) {
    return axios
      .post(SLIDER_IMAGE, {
        filter: { _id: id },
        sort: { _created: -1 },
      })
      .then(({ data: { entries } }) => entries[0]);
  }
}

export default Api;
